module.exports = __webpack_public_path__ + "static/media/mdIcon.3778860c.svg";